export interface ReleaseNotes {
  buildVersion: string;
}

export class ReleaseNotesConfig {
  static readonly componentName = 'rating-2.0-release-notes';
  static readonly releaseNotesInitialState: ReleaseNotes = { buildVersion: 'initState' };
}
